/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { FC, useState } from 'react';
import { Grid } from '@mui/material';
import { Box } from '@mui/system';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowLeft from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import ExitToAppRoundedIcon from '@mui/icons-material/ExitToAppRounded';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';

import { To, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { environment } from '../../../environments/environment';
import { useAuth } from '../../../contexts';

import './styles.scss';

export enum TopBarMode {
  Standard = 'Standard',
  BackButton = 'BackButton',
  NoNav = 'NoNav'
}

export interface TopBarProps {
  mode?: TopBarMode;
  pageName?: string;
  backTo?: string;
}

const TopBar: FC<TopBarProps> = (props) => {
  const {
    mode = TopBarMode.Standard,
    pageName = '',
    backTo = '',
  } = props;

  const navigate = useNavigate();

  const { logout, isLogged } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const closeMenu = () => setIsMenuOpen(false);
  const openMenu = () => setIsMenuOpen(true);

  if (!environment.disableAuth0 && !isLogged) return null;

  const onBackButtonClicked = () => {
    navigate((backTo || -1) as To);
  };

  const getLeftIcon = (menuMode: TopBarMode) => {
    switch (menuMode) {
      case TopBarMode.Standard:
        return !isMenuOpen && (
          <Box
            role="button"
            className="icon-wrapper open-menu"
            tabIndex={0}
            onClick={openMenu}
            onKeyPress={openMenu}
          >
            <MenuIcon />
          </Box>
        );
      case TopBarMode.BackButton:
        return (
          <Box
            role="button"
            className="icon-wrapper open-menu arrow-back"
            tabIndex={0}
            onClick={onBackButtonClicked}
            onKeyPress={onBackButtonClicked}
          >
            <ArrowLeft />
            {' '}
            <span className="page-name">{pageName}</span>
          </Box>
        );
      default:
    }
    return null;
  };

  const getRightContent = (menuMode: TopBarMode) => {
    switch (menuMode) {
      default:
        return (
          <img
            className="logo"
            alt="Study Cash"
            src={`${environment.cdnUrl}/images/studycash-logo.svg`}
            onClick={() => menuMode !== TopBarMode.NoNav && navigate('/')}
          />
        );
    }
  };

  const editPersonalDetails = () => {
    navigate('/patient-details/edit');
    closeMenu();
  };

  const { t } = useTranslation();

  return (
    <>
      <Box className="top-bar">
        <Grid className="top-bar-grid" container spacing={1}>
          <Grid item xs={2} display="flex" justifyContent="center">
            {getLeftIcon(mode)}
          </Grid>
          <Grid
            item
            xs={9}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            {getRightContent(mode)}
          </Grid>
        </Grid>
      </Box>
      <Box className={`slide-menu ${isMenuOpen ? 'active' : ''}`}>
        <Grid item xs={1} display="flex" justifyContent="end">
          <div
            role="button"
            className="icon-wrapper close-menu"
            tabIndex={0}
            onClick={closeMenu}
            onKeyPress={closeMenu}
          >
            <CloseIcon />
          </div>
        </Grid>
        <MenuList>
          <MenuItem onClick={editPersonalDetails}>
            <ListItemIcon>
              <PersonOutlineIcon />
            </ListItemIcon>
            <ListItemText>{t('Personal Details')}</ListItemText>
          </MenuItem>
          <MenuItem onClick={logout}>
            <ListItemIcon>
              <ExitToAppRoundedIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t('Log Out')}</ListItemText>
          </MenuItem>
        </MenuList>
      </Box>
    </>
  );
};

export default TopBar;
